/**
 * The three overdue bands by lower bound of `cadenceDaysOut` (days past the
 * account's configured cadence). Bands are exclusive and inclusive-lower:
 *   30 -> [30, 60), 60 -> [60, 90), 90 -> [90, ∞)
 */
enum RecordsCadenceEffectivenessBand {
  THIRTY = 30,
  SIXTY = 60,
  NINETY = 90,
}

export const RECORDS_CADENCE_EFFECTIVENESS_BANDS = [
  RecordsCadenceEffectivenessBand.THIRTY,
  RecordsCadenceEffectivenessBand.SIXTY,
  RecordsCadenceEffectivenessBand.NINETY,
] as const;

export const DEFAULT_RECORDS_CADENCE_EFFECTIVENESS_BAND = RecordsCadenceEffectivenessBand.THIRTY;

export default RecordsCadenceEffectivenessBand;
